import { Box } from "@mui/system";
import React, { useContext, useState } from "react";

import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import Grid from "@mui/material/Grid";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
//import DialpadOutlinedIcon from '@mui/icons-material/DialpadOutlined';
//import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import { CircularProgress, Typography } from "@mui/material";
import { CustomButton } from "../CustomButton/CustomButton";
import {
  inputBoxStyle,
  inputIconStyle,
  SignInAndSignUpValues,
} from "./SignInAndSignUp";

import "./phoneInput.styles.css";
import CustomInput from "../CustomInput/CustomInput";
// import "react-phone-number-input/style.css";

import { useForm } from "../../Hooks/useForm";
import { Theme } from "../../config/aws-exports";
import Auth from "@aws-amplify/auth";
import validateSignUp from "./SignInSignUpValidationRules/SignUpValidationRules";
import { HeadingPrimary } from "../Styles/Heading";
import cognitoValidation from "./SignInSignUpValidationRules/SignInCognitoValidationRules";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import Swal from "sweetalert2";
import { API } from "aws-amplify";
import config from "../../config/aws-exports";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";
const SignUp = () => {
  const { setSignUp, setSignIn } = useContext(SignInAndSignUpValues);

  const [errors, setErrors] = useState({});

  const [signUpBtnLoader, setSignUpBtnLoader] = useState(false);
  const {
    values,
    handleChange,
    handleClickShowPassword,
    handleMouseDownPassword,
  } = useForm({ showPassword: false });

  const countryCodes = [
    { code: "+1", country: "United States/Canada" },
    { code: "+7", country: "Russia/Kazakhstan" },
    { code: "+20", country: "Egypt" },
    { code: "+27", country: "South Africa" },
    { code: "+30", country: "Greece" },
    { code: "+31", country: "Netherlands" },
    { code: "+32", country: "Belgium" },
    { code: "+33", country: "France" },
    { code: "+34", country: "Spain" },
    { code: "+36", country: "Hungary" },
    { code: "+39", country: "Italy" },
    { code: "+40", country: "Romania" },
    { code: "+41", country: "Switzerland" },
    { code: "+43", country: "Austria" },
    { code: "+44", country: "United Kingdom" },
    { code: "+45", country: "Denmark" },
    { code: "+46", country: "Sweden" },
    { code: "+47", country: "Norway" },
    { code: "+48", country: "Poland" },
    { code: "+49", country: "Germany" },
    { code: "+52", country: "Mexico" },
    { code: "+53", country: "Cuba" },
    { code: "+54", country: "Argentina" },
    { code: "+55", country: "Brazil" },
    { code: "+56", country: "Chile" },
    { code: "+57", country: "Colombia" },
    { code: "+58", country: "Venezuela" },
    { code: "+60", country: "Malaysia" },
    { code: "+61", country: "Australia" },
    { code: "+62", country: "Indonesia" },
    { code: "+63", country: "Philippines" },
    { code: "+64", country: "New Zealand" },
    { code: "+65", country: "Singapore" },
    { code: "+66", country: "Thailand" },
    { code: "+81", country: "Japan" },
    { code: "+82", country: "South Korea" },
    { code: "+84", country: "Vietnam" },
    { code: "+86", country: "China" },
    { code: "+90", country: "Turkey" },
    { code: "+91", country: "India" },
    { code: "+92", country: "Pakistan" },
    { code: "+93", country: "Afghanistan" },
    { code: "+94", country: "Sri Lanka" },
    { code: "+95", country: "Myanmar" },
    { code: "+98", country: "Iran" },
    { code: "+211", country: "South Sudan" },
    { code: "+212", country: "Morocco" },
    { code: "+213", country: "Algeria" },
    { code: "+216", country: "Tunisia" },
    { code: "+218", country: "Libya" },
    { code: "+351", country: "Portugal" },
    { code: "+353", country: "Ireland" },
    { code: "+358", country: "Finland" },
    { code: "+380", country: "Ukraine" },
    { code: "+880", country: "Bangladesh" },
    { code: "+966", country: "Saudi Arabia" },
    { code: "+971", country: "United Arab Emirates" },
    { code: "+972", country: "Israel" },
  ];

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (Object.keys(validateSignUp(values)).length !== 0) {
      setErrors(validateSignUp(values));
      return;
    } else {
      const { name, lname, signUpPassword, email } = values;
      setSignUpBtnLoader(true);
      try {
        const response = await Auth.signUp({
          username: email.toLowerCase(),
          password: signUpPassword,
          attributes: {
            email, // optional
            // phone_number: values.phoneNumber, // optional - E.164 number convention
            // other custom attributes
            name: name + " " + lname,
            locale: "TenantOne",
          },
        });

        if (response) {
          console.log(response);
          let body = {
            tenant: config.tenant,
            type: "signup",
            eid: response.userSub,
            emailid: email,
            gen: 0,
            first_name: name,
            last_name: lname,

            department: values.department,
            designation: values.designation,
            organization: values.organization,
            officeAddress: values.officeAddress,
            country: values.country,
            city: values.city,
            state: values.state,
            pin: values.pin,
            gst: values.gst,
            pan: values.pan,
            std: values.std,
            dev: 2,
            st_id: config.stid,
            cno: values.phoneNumber,
            scheme: config.schema,
          };
          console.log("body==", body);
          addUser(body);
          Swal.fire({
            title: "Successfully signed Up!",
            text: "A verification link will be sent to your registered email address. Please click on the link to verify and then proceed to log in to the application!",
            icon: "success",
            confirmButtonColor: Theme.color.primary,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              setSignUp(false);
              setSignIn(true);
              setSignUpBtnLoader(false);
            }
          });
        }
        setSignUpBtnLoader(false);
      } catch (error) {
        console.log("error signing up:", error);
        setErrors(cognitoValidation(error));
        setSignUpBtnLoader(false);
      }
    }
  };

  const addUser = async (user) => {
    const bodyParam = {
      body: user,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    try {
      await API.post(config.aws_cloud_logic_custom_name, "/addUser", bodyParam);
    } catch (err) {
      console.log("error adding user:", err);
    }
  };
  return (
    <React.Fragment>
      <Box
        sx={{
          textAlign: { xs: "left", sm: "center" },
          pl: { xs: "65px", sm: 0 },
          width: "100%",
        }}
      >
        <HeadingPrimary>Create an account</HeadingPrimary>
      </Box>
      <form
        onSubmit={handleSubmit}
        noValidate
        autoComplete="off"
        style={{ width: "100%", maxWidth: "1000px", margin: "auto" }}
      >
        <Grid container spacing={2}>
          {/* First Name */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={inputBoxStyle}>
              <CustomInput
                id="input-Uname"
                placeholder="First Name *"
                name="name"
                value={values.name || ""}
                error={errors.name}
                type="text"
                onChange={handleChange("name")}
              >
                <PersonOutlineOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid>
          {/* Last Name */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={inputBoxStyle}>
              <CustomInput
                placeholder="Last Name *"
                name="lname"
                value={values.lname || ""}
                error={errors.lname}
                type="text"
                onChange={handleChange("lname")}
              >
                <PersonOutlineOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid>
          {/* Designation */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={inputBoxStyle}>
              <CustomInput
                placeholder="Designation *"
                name="designation"
                value={values.designation || ""}
                error={errors.designation}
                type="text"
                onChange={handleChange("designation")}
              >
                <BadgeOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid>
          {/* Department */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={inputBoxStyle}>
              <CustomInput
                placeholder="Department *"
                name="department"
                value={values.department || ""}
                error={errors.department}
                type="text"
                onChange={handleChange("department")}
              >
                <AccountTreeOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid>
          {/* Organization */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={inputBoxStyle}>
              <CustomInput
                placeholder="Organization *"
                name="organization"
                value={values.organization || ""}
                error={errors.organization}
                type="text"
                onChange={handleChange("organization")}
              >
                <BusinessOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid>
          {/* Office Address */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={inputBoxStyle}>
              <CustomInput
                placeholder="Office Address *"
                name="officeAddress"
                value={values.officeAddress || ""}
                error={errors.officeAddress}
                type="text"
                onChange={handleChange("officeAddress")}
              >
                <LocationOnOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid>

          {/* City */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={inputBoxStyle}>
              <CustomInput
                placeholder="Country *"
                name="country"
                value={values.country || ""}
                error={errors.country}
                type="text"
                onChange={handleChange("country")}
              >
                <LocationCityOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid>
          {/* City */}
          {/* <Grid item xs={12} sm={6} md={3}>
            <Box sx={inputBoxStyle}>
              <CustomInput
                placeholder='City'
                name='city'
                value={values.city || ''}
                error={errors.city}
                type='text'
                onChange={handleChange('city')}
              >
                <LocationCityOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid>

          {/* State */}
          {/* <Grid item xs={12} sm={6} md={3}>
            <Box sx={inputBoxStyle}>
              <CustomInput
                placeholder='State'
                name='state'
                value={values.state || ''}
                error={errors.state}
                type='text'
                onChange={handleChange('state')}
              >
                <MapOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid> */}

          <Grid item xs={12} sm={6} md={3}>
            <Box
              component="div"
              sx={{
                display: "flex",
                gap: 2,
                width: "100%",
                ...inputBoxStyle,
              }}
            >
              <LocationCityOutlinedIcon sx={inputIconStyle} />
              <CustomInput
                placeholder="City *"
                name="city"
                value={values.city || ""}
                error={errors.city}
                type="text"
                onChange={handleChange("city")}
              ></CustomInput>
              <MapOutlinedIcon sx={inputIconStyle} />
              <CustomInput
                placeholder="State *"
                name="state"
                value={values.state || ""}
                error={errors.state}
                type="text"
                onChange={handleChange("state")}
              ></CustomInput>
            </Box>
          </Grid>

          {/* Mobile */}
          <Grid item xs={12} sm={6} md={3}>
            {/* <Box
              component='div'
              sx={{
                display: 'flex',
                gap: 2,
                width: '100%',
                ...inputBoxStyle,
              }}
            > */}

            <Box
              component="div"
              sx={{
                display: "flex",
                alignItems: "flex-end",
                gap: 2,
                width: "100%",
                ...inputBoxStyle,
              }}
            >
              <PhoneIphoneIcon sx={inputIconStyle} />

              {/* STD Dropdown */}
              <FormControl
                variant="standard"
                sx={{
                  width: "120px",

                  "& .MuiInputLabel-root": {
                    color: "rgba(0, 0, 0, 0.3)", // same as other input labels
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "rgba(0, 0, 0, 0.6)", // keep same color when focused
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "#1976d2", // same as phone field
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "#1976d2",
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottomColor: "#1976d2",
                  },
                }}
                error={Boolean(errors.std)}
              >
                <InputLabel id="std-select-label">STD *</InputLabel>
                <Select
                  labelId="std-select-label"
                  id="input-std"
                  name="std"
                  value={values.std || ""}
                  error={errors.std}
                  onChange={handleChange("std")}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200, // controls dropdown height
                      },
                    },
                  }}
                >
                  {countryCodes.map((item, idx) => (
                    <MenuItem key={idx} value={item.code}>
                      {item.code}
                    </MenuItem>
                  ))}
                </Select>

                {errors.std && <FormHelperText>{errors.std}</FormHelperText>}
              </FormControl>

              {/* Phone Number */}
              <Box sx={{ flexGrow: 1 }}>
                <CustomInput
                  id="input-phone"
                  placeholder="Enter phone number *"
                  name="phoneNumber"
                  value={values.phoneNumber || ""}
                  error={errors.phoneNumber}
                  type="number"
                  onChange={handleChange("phoneNumber")}
                />
              </Box>
              {/* <PhoneInput
              defaultCountry="IN"
              className="PhoneInput"
              name="phone"
              style={errors.phoneNumber && { borderBottomColor: "#D32f2f" }}
              placeholder="Enter phone number"
              value={values.phone_number || ""}
              onChange={(value) =>
                setValues((values) => ({ ...values, phone_number: value }))
              }
            />
            {
              <p
                style={{
                  color: "#D32f2f",
                  fontSize: "14px",
                  fontFamily: "Roboto ",
                  marginTop: ".5rem",
                }}
              >
                {errors.phoneNumber}
              </p>
            } */}
            </Box>
            {/* <Box
              component='div'
              sx={{
                display: 'flex',
                gap: 2,
                width: '100%',
                ...inputBoxStyle,
              }}
            >
              <PhoneIphoneIcon sx={inputIconStyle} />
              <CustomInput
                id='input-std'
                placeholder='STD'
                name='std'
                value={values.std || ''}
                error={errors.std}
                type='number'
                onChange={handleChange('std')}
              />

              <CustomInput
                id='input-phone'
                placeholder='Phone'
                name='phone'
                value={values.phone || ''}
                error={errors.phone}
                type='number'
                onChange={handleChange('phone')}
              />

              <CustomInput
                id='input-mobile'
                placeholder='Mobile'
                name='mobile'
                value={values.mobile || ''}
                error={errors.mobile}
                type='number'
                onChange={handleChange('mobile')}
              />
            </Box> */}
          </Grid>

          {/* PIN */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={inputBoxStyle}>
              <CustomInput
                placeholder="PIN Code *"
                name="pin"
                value={values.pin || ""}
                error={errors.pin}
                type="number"
                onChange={handleChange("pin")}
              >
                <PinDropOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid>

          {/* GST */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={inputBoxStyle}>
              <CustomInput
                placeholder="GST Number"
                name="gst"
                value={values.gst || ""}
                error={errors.gst}
                type="text"
                onChange={handleChange("gst")}
              >
                <ReceiptLongOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid>
          {/* PAN */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={inputBoxStyle}>
              <CustomInput
                placeholder="PAN"
                name="pan"
                value={values.pan || ""}
                error={errors.pan}
                type="text"
                onChange={handleChange("pan")}
              >
                <CreditCardOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid>

          {/* Email */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={inputBoxStyle}>
              <CustomInput
                placeholder="Email *"
                name="email"
                type="email"
                value={values.email || ""}
                error={errors.email}
                onChange={handleChange("email")}
              >
                <EmailOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Box component="div" sx={inputBoxStyle}>
              <CustomInput
                id="input-signUpPassword"
                placeholder="Password *"
                type="password"
                name="signUpPassword"
                inputValues={values}
                value={values.signUpPassword || ""}
                error={errors.password}
                handleClickShowPassword={handleClickShowPassword}
                handleMouseDownPassword={handleMouseDownPassword}
                onChange={handleChange("signUpPassword")}
              >
                <LockOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
            </Box>
          </Grid>
          {/* Sign Up Button */}
          {/* <Grid item xs={12}>
            <Box
              component='div'
              sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}
            >
              {signUpBtnLoader ? (
                <CustomButton disabled loading='true'>
                  <CircularProgress color='inherit' size={20} />
                </CustomButton>
              ) : (
                <CustomButton primary type='submit'>
                  SignUp
                </CustomButton>
              )}
            </Box>
            <Typography
              onClick={() => {
                setSignIn(true);
                setSignUp(false);
              }}
              variant='caption'
              display='block'
              gutterBottom
              sx={{ fontSize: '1rem', textAlign: 'center', cursor: 'pointer' }}
            >
              Already have an account?
              <span
                style={{
                  textDecoration: 'underline',
                  color: Theme.color.secondary,
                  fontWeight: 'bold',
                }}
              >
                Login here
              </span>
            </Typography>
          </Grid> */}
        </Grid>
        <Box
          component="div"
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: { xs: "flex-start", sm: "center" },
            pl: { xs: "80px", sm: 0 },
            mb: 3,
          }}
        >
          {signUpBtnLoader ? (
            <CustomButton disabled loading="true">
              <CircularProgress color="inherit" size={20} />
            </CustomButton>
          ) : (
            <CustomButton primary type="submit">
              SignUp
            </CustomButton>
          )}
        </Box>
        <Typography
          onClick={() => {
            setSignIn(true);
            setSignUp(false);
          }}
          variant="caption"
          display="block"
          gutterBottom
          sx={{
            fontSize: "1rem",
            cursor: "pointer",
            textAlign: { xs: "left", sm: "center" },
            pl: { xs: "10px", sm: 0 },
            width: "100%",
          }}
        >
          Already have an account?{" "}
          <span
            style={{
              textDecoration: "underline",
              color: Theme.color.secondary,
              fontWeight: "bold",
            }}
          >
            Login here
          </span>
        </Typography>
      </form>
    </React.Fragment>
  );
};

export default SignUp;
